// Vendor
import { combineReducers, createReducer, on } from '@ngrx/store';
// Constants
import { STATUS_ERROR, STATUS_NONE, STATUS_PENDING, STATUS_SUCCESS } from 'NotesApp/ts/apps/notes-app/notes.constants';
// Actions
import { collapseNote, deleteNote, expandNote, fetchNotes, saveNote, setNotesFetchFailure, setNotesFetchSuccess, setSelectedNote, updateNote, } from './notes.actions';
export const fetchRequest = createReducer({ status: STATUS_NONE, error: null }, on(fetchNotes, () => {
    return { status: STATUS_PENDING, error: null };
}), on(setNotesFetchFailure, () => {
    return { status: STATUS_ERROR, error: null };
}), on(setNotesFetchSuccess, () => {
    return { status: STATUS_SUCCESS, error: null };
}));
export const notesItems = createReducer([], on(saveNote, (state, action) => {
    return [...state, { ...action.note, expanded: false }];
}), on(collapseNote, (state, action) => {
    return state.map((note) => {
        if (note.id === action.noteId) {
            return { ...note, expanded: false };
        }
        return note;
    });
}), on(expandNote, (state, action) => {
    return state.map((note) => {
        if (note.id === action.noteId) {
            return { ...note, expanded: true };
        }
        return note;
    });
}), on(setNotesFetchSuccess, (state, action) => {
    return action.notes.map((note) => {
        return { ...note, expanded: false };
    });
}), on(deleteNote, (state, action) => {
    return state.filter((note) => note.id !== action.noteId);
}), on(updateNote, (state, action) => {
    return state.map((note) => {
        if (note.id !== action.note.id)
            return note;
        return { ...action.note, expanded: false };
    });
}));
export const selectedNote = createReducer(undefined, on(setSelectedNote, (state, action) => {
    return action.selectedNote;
}));
export const notesModal = combineReducers({
    fetchRequest,
    notesItems,
    selectedNote,
});
